var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.266 6.48379C15.2579 7.25127 15.2579 8.74873 14.266 9.51621C11.2685 11.8356 7.92127 13.6638 4.34973 14.9322L3.69725 15.164C2.44898 15.6073 1.13047 14.7628 0.96148 13.4742C0.489321 9.87399 0.489321 6.12601 0.961481 2.52579C1.13047 1.23724 2.44898 0.392684 3.69725 0.836025L4.34973 1.06776C7.92127 2.33624 11.2685 4.16439 14.266 6.48379ZM13.3481 8.32988C13.5639 8.1629 13.5639 7.8371 13.3481 7.67012C10.4762 5.44801 7.26945 3.69653 3.84771 2.48126L3.19523 2.24952C2.87028 2.13411 2.49685 2.35407 2.44874 2.72084C1.99357 6.19158 1.99357 9.80842 2.44874 13.2792C2.49685 13.6459 2.87028 13.8659 3.19523 13.7505L3.8477 13.5187C7.26944 12.3035 10.4762 10.552 13.3481 8.32988Z",
    fill: "#FFFCEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPlay);
export default __webpack_public_path__ + "static/media/ico-play.239e1efe530286beb4ced0ca3f9c2174.svg";
export { ForwardRef as ReactComponent };